import { Box, Modal, CircularProgress } from "@mui/material";

const Loader = (props: any) => {
  const style = {
    outline: "none",
  };
  
  return (
    <Box>
      {props.isLoad ? (
        <Modal 
          open
          sx={{
            "& .MuiBackdrop-root": {
              backgroundColor: "rgba(15, 23, 42, 0.6)",
              backdropFilter: "blur(4px)",
            },
          }}
        >
          <Box 
            className="loader_loading" 
            sx={{
              ...style,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <Box
              sx={{
                backgroundColor: "#ffffff",
                borderRadius: "16px",
                padding: "32px",
                boxShadow: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <CircularProgress 
                size={48}
                thickness={4}
                sx={{
                  color: "#1c9aaa",
                }}
              />
              <Box
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#64748b",
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                }}
              >
                Loading...
              </Box>
            </Box>
          </Box>
        </Modal>
      ) : (
        ""
      )}
    </Box>
  );
};

export default Loader;
